document.addEventListener('DOMContentLoaded', function () {
  const shopLook = document.querySelectorAll('.ed-shop-the-look');

  shopLook.forEach((look, index) => {
    const swiperContainer = look.querySelector('.shop-look-swiper');

    if (swiperContainer) {
      // Initialize a new Swiper instance for each collection
      new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 8,
        autoHeight: true,
        autoWidth: true,
        centeredSlides: true,
        initialSlide: 1,
        breakpoints: {
          750: {
            slidesPerView: 2,
          }
        },
      });
    }
  });
});